import React, { useEffect, useState } from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import PageHeader from "@/components/layout/PageHeader";
import { api } from "@/lib/api";
import SlotPreview from "@/pages/profile/SlotPreview";

export default function SlotViewer() {
  const [clinicians, setClinicians] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [selectedSlot, setSelectedSlot] = useState(null);

  useEffect(() => {
    api.get("/availability/clinicians").then((r) => {
      setClinicians(r.data.items || []);
      if ((r.data.items || []).length) setSelectedId(r.data.items[0].id);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="slot-viewer-page">
      <PageHeader title="Teleconsultation Availability" subtitle="View a clinician's open 30-minute slots. Booked slots are greyed out." />
      <div className="hah-card p-5 mb-4 max-w-md">
        <label className="text-xs uppercase tracking-wider text-[#6B7280] mb-1.5 block">Clinician</label>
        <Select value={selectedId} onValueChange={(v) => { setSelectedId(v); setSelectedSlot(null); }}>
          <SelectTrigger data-testid="clinician-select"><SelectValue placeholder="Select a clinician" /></SelectTrigger>
          <SelectContent>
            {clinicians.map((c) => (
              <SelectItem key={c.id} value={c.id}>{c.name} · <span className="capitalize">{(c.role_code || "").replace(/_/g, " ")}</span></SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {selectedId && (
        <SlotPreview
          userId={selectedId}
          title="Open slots"
          selected={selectedSlot?.start}
          onSelect={(s) => setSelectedSlot(s)}
        />
      )}
      {selectedSlot && (
        <div className="mt-4 rounded-lg border border-[#0B7E8C]/40 bg-[#0B7E8C]/5 px-4 py-3 text-sm text-[#0B7E8C]" data-testid="selected-slot-banner">
          Selected slot: <strong>{selectedSlot.start}–{selectedSlot.end}</strong>. (Booking is completed from the teleconsultation scheduler.)
        </div>
      )}
    </div>
  );
}
